import React from "react";
import { IoIosArrowForward } from "react-icons/io";
import { RiSettings4Line } from "react-icons/ri";
function IndustrialAutomation() {
  return (
    <>
      {/* Page Header Section */}
      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <h1 className="display-3 text-white animated slideInRight">
            Product Support
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animated slideInRight mb-0">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item">
                <a href="/">Services</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Product Support
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <h6 className="text-secondary">UNDERSTANDING YOUR NEEDS</h6>
            <h3 className="">
              Our approach to website design and digital marketing prioritizes
              ROI and addresses your unique challenges.
            </h3>
            <p className="">
              Ambitious business goals. Big dreams. Overstretched marketing
              teams—often a team of one. This is the reality for many
              manufacturing and industrial companies, and it’s a reality that
              we’re accustomed to. At Windmill Strategy, we’ll meet you where
              you are. We’ll build a nimble industrial digital marketing
              strategy that prioritizes ROI and guides you toward digital
              marketing success through modern websites, tools, and initiatives
              that address your unique needs.
            </p>
            <div className="d-flex">
              <h6 className="text-danger">SCHEDULE A CALL TO LEARN MORE</h6>
              <IoIosArrowForward />
            </div>
          </div>
          <div className="col-lg-6">
            <img
              className=""
              alt=""
              src={require("../assets/img/Service/Industrial Automation/b.jpg")}
              style={{ height: "80%", width: "100%" }}
            ></img>
          </div>
        </div>
      </div>

      <div
        className="container-fluid p-4 "
        style={{ backgroundColor: "#E9ECEF" }}
      >
        <h5 className="text-secondary text-center">CASE STUDIES</h5>
        <h3 className="text-center">
          How our process has worked for other B2B industrial companies
        </h3>
        <div className="row mt-5">
          <div className="col-lg-4">
            <div className="card">
              <img
                alt=""
                className=""
                src={require("../assets/img/Service/Industrial Automation/a.jpg")}
              ></img>
              <p className="text-secondary p-2">DIGITAL MARKETING</p>
              <h5 className=" p-2">
                A multiple approach simplifies content management and improves
                user experience for a complex industrial website
              </h5>
              <p className=" p-2">
                A multiple approach simplifies content management and improves
                user experience for a complex industrial website A multiple
                approach simplifies content management and improves user
                experience for a complex industrial website
              </p>
              <div className="d-flex  p-2">
                <h6 className="text-danger">SCHEDULE A CALL TO LEARN MORE</h6>
                <IoIosArrowForward />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card">
              <img
                alt=""
                className=""
                src={require("../assets/img/Service/Industrial Automation/a.jpg")}
              ></img>
              <p className="text-secondary p-2">DIGITAL MARKETING</p>
              <h5 className=" p-2">
                A multiple approach simplifies content management and improves
                user experience for a complex industrial website
              </h5>
              <p className=" p-2">
                A multiple approach simplifies content management and improves
                user experience for a complex industrial website A multiple
                approach simplifies content management and improves user
                experience for a complex industrial website
              </p>
              <div className="d-flex  p-2">
                <h6 className="text-danger">SCHEDULE A CALL TO LEARN MORE</h6>
                <IoIosArrowForward />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card">
              <img
                alt=""
                className=""
                src={require("../assets/img/Service/Industrial Automation/a.jpg")}
              ></img>
              <p className="text-secondary p-2">DIGITAL MARKETING</p>
              <h5 className=" p-2">
                A multiple approach simplifies content management and improves
                user experience for a complex industrial website
              </h5>
              <p className=" p-2">
                A multiple approach simplifies content management and improves
                user experience for a complex industrial website A multiple
                approach simplifies content management and improves user
                experience for a complex industrial website
              </p>
              <div className="d-flex  p-2">
                <h6 className="text-danger">SCHEDULE A CALL TO LEARN MORE</h6>
                <IoIosArrowForward />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-5">
        <div className="row">
          <div className="col-lg-6">
            <h6 className="text-secondary">
              B2B INDUSTRIAL WEB DESIGN & DEVELOPMENT
            </h6>
            <h3 className="">
              Successful industrial websites are easy to use and communicate
              relevant information with clarity and precision.
            </h3>
            <p className="">
              Engineers, purchasers, and other industrial customers are
              technical and smart, but that doesn’t mean they’ll immediately
              understand how your products and services are relevant to the
              outcomes their business hopes to achieve. To make the connection,
              your website needs to communicate the value and quality of your
              offerings while providing sufficient specifications for engineers
              and other technically minded buyers. Custom or OEM products and
              services require case studies and detailed information to build
              trust and demonstrate that what you’ve done in the past applies to
              their unique needs and their current problem. A clean, modern UX
              with clear navigation will make it easier for users to sort
              through the information.
            </p>
            <div className="d-flex">
              <h6 className="text-danger">
                UPGRADE YOUR MARKETING AND INCREASE YOUR IMPACT
              </h6>
              <IoIosArrowForward />
            </div>
          </div>
          <div className="col-lg-6">
            <img
              className=""
              alt=""
              src={require("../assets/img/Service/Industrial Automation/b.jpg")}
              style={{ height: "100%", width: "100%" }}
            ></img>
          </div>
        </div>
      </div>

      <div
        className="container-fluid p-5 mt-5"
        style={{ backgroundColor: "#EFEFEF" }}
      >
        <h6 className="text-center text-secondary">WHY WINDMILL STRATEGY</h6>
        <h4 className="text-center">
          We’ll help you provide your customers and prospects with a great B2B
          digital experience that engages niche industrial audiences.
        </h4>
        <p className="text-center mt-3">
          To achieve higher quality and quantity lead generation, you need to
          offer a great digital experience with a website that performs well
          technically, share relevant information that speaks your customer’s
          language, and completely avoid marketing fluff and irrelevant B2C
          strategies.
        </p>
        <p className="text-center mt-3">
          Our approach starts with identifying your target personas, their
          challenges, and how they communicate. This allows us to build an
          efficient and focused plan that can leverage web design, SEO and
          inbound marketing, sales enablement and ABM efforts to attract and
          convert your audience. In this way, we have helped industrial
          businesses strategize, build credibility, gain market share, and
          surpass the competition since 2006.
        </p>
        <div class="row mt-5">
          <div class="col-md-3 col-sm-6 mb-4">
            <div class="feature-card">
              <div class="feature-icon text-center fs-3">
                <i class="fas fa-bullseye"></i>
              </div>
              <h4>Establish Leadership</h4>
              <p>
                To outperform competitors and attract talent, your website
                should stake out a clear, credible position and show that it is
                a forward-looking industry leader.
              </p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-4">
            <div class="feature-card">
              <div class="feature-icon text-center fs-3">
                <i class="fas fa-magnet"></i>
              </div>
              <h4>Showcase & Engage</h4>
              <p>
                Offer an impressive, rich experience that helps technical
                audiences find information and solutions quickly. Educate,
                inform, and inspire your ideal customers.
              </p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-4">
            <div class="feature-card">
              <div class="feature-icon text-center fs-3">
                <i class="fas fa-chart-line"></i>
              </div>
              <h4>Generate Leads</h4>
              <p>
                Layer in brand strategy and leverage brand perception. Fine-tune
                the website to attract quality leads, and connect to the CRM and
                MAT for marketing and sales nurturing.
              </p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 mb-4">
            <div class="feature-card">
              <div class="feature-icon text-center fs-3">
                <i class="fas fa-tools"></i>
              </div>
              <h4>Use Better Tools</h4>
              <p>
                Better tools mean better load times, strong UX, functionality
                for languages and distributor portals, and edit-ability and
                flexibility as a marketing tool and to support sales efforts.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5 ">
        <h4 className="text-center">
          Control Panel Design, Assembly, and Repair Solutions
        </h4>
      </div>

      <div className="container mt-5">
        <div className="row">
          <div className="col-lg-6">
            <img
              className=""
              alt=""
              src={require("../assets/img/Service/Industrial Automation/b.jpg")}
              style={{ height: "100%", width: "100%" }}
            ></img>
          </div>
          <div className="col-lg-6">
            <p className="">
              When machines have been operating for two decades or longer, the
              time eventually comes to replace their controls. This is often
              because of obsolete electrical components or the availability of
              more efficient and productive technology. Companies also seek
              upgrades to enhance safety and reliability in industrial
              environments.
            </p>
            <p className="mt-3">
              At Sure Controls, we bring years of experience in designing new
              industrial control panel designs and refurbishing existing ones.
              Our team excels in delivering comprehensive, expert design and
              assembly solutions.
            </p>
            <p className="mt-3">
              We take pride in using readily available, cost-effective
              components that we can easily replace, reducing maintenance costs.
            </p>
            <p className="mt-3">
              Moreover, we carefully design our panels to optimize process
              control, minimize energy consumption, and lower operational
              expenses. With our solutions, your manufacturing facility can
              operate at its peak performance.
            </p>
            <div className="d-flex">
              <h6 className="text-danger">CONTACT US TO GET STARTED</h6>
              <IoIosArrowForward />
            </div>
          </div>
        </div>
      </div>
      <div
        className="container-fluid p-5 mt-5"
        style={{ backgroundColor: "#EFEFEF" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mt-5">
              <h6 className="">INDUSTRIAL DIGITAL MARKETING CAMPAIGNS</h6>
              <h4 className="">
                We’ll help you drive targeted traffic to your website.
              </h4>
              <p className="">
                With technical and niche offerings, you’re not trying to get
                every person in the world to come to your website, but you are
                looking for a highly specific audience. You want your website to
                be a place to begin client relationships and drive quality
                leads, not simply quantity. To achieve that goal, you need
                marketing campaigns that appeal to the right audience, as well
                as marketing automation to help harness and nurture new leads.
              </p>
              <div className="d-flex">
                <h6 className="text-danger">GET A STARTED TODAY</h6>
                <IoIosArrowForward />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="row">
                <div className="col-lg-1 mt-3">
                  <RiSettings4Line size={45} />
                </div>
                <div className="col-lg-11">
                  <h6 className="">Smart Solutions</h6>
                  <p className="">
                    We listen to your unique needs, then deliver smart,
                    high-quality solutions that are right-sized to meet your
                    objectives and your budget.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-1 mt-5">
                  <RiSettings4Line size={45} />
                </div>
                <div className="col-lg-11 mt-4">
                  <h6 className="">Communication & Collaboration</h6>
                  <p className="">
                    Open, honest communication is at the core of every
                    engagement—ensuring there are no surprises. Collaboration
                    throughout keeps everyone focused on a common goal, allowing
                    your team to gain new skills and knowledge at every stage.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-1 mt-5 ">
                  <RiSettings4Line size={45} />
                </div>
                <div className="col-lg-11 mt-4">
                  <h6 className="">Powerful Processes</h6>
                  <p className="">
                    Our proven processes and the entire team’s commitment to
                    continuous improvement lead to increased efficiency,
                    delivering innovation and excellent results while keeping
                    projects on schedule.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IndustrialAutomation;
